import { Box, Heading, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

type Props = {
  label: string;
  value: ReactNode;
  note?: string;
  dimmed?: boolean;
};

const Kpi = ({ label, value, note, dimmed }: Props): JSX.Element => (
  <Box bg="gray.50" borderRadius="md" p="4" opacity={dimmed ? 0.5 : 1}>
    <Text fontWeight="semibold" color="gray.600">
      {label}
    </Text>
    <Heading size="2xl">{value}</Heading>
    {note && (
      <Text color="gray.600" fontSize="sm">
        {note}
      </Text>
    )}
  </Box>
);

export default Kpi;
